import { CfBannerPopupProps } from "../types";
import { CfCtaReference } from "components/CtaReference/types";
import { CfImageProps } from "components/Image/types";
import { convertCfImageProps } from "components/Image/CfImage";
import { getUrlLink } from "components/CtaReference";
import BannerPopup from "..";
import React from "react";

export const convertCfBannerPopupProps = ({
  slug,
  image,
  ctaBanner,
}: CfBannerPopupProps) => {
  const props = {
    image: convertCfImageProps(image[0] as CfImageProps),
    slug,
    ctaBanner: {
      url: getUrlLink(ctaBanner[0] as CfCtaReference) as string,
      dataTracking: ctaBanner[0].dataTracking,
      targetBlank: ctaBanner[0].targetBlank,
    },
  };
  return props;
};

const CfBannerPopup = (props: CfBannerPopupProps) => {
  return <BannerPopup {...convertCfBannerPopupProps(props)} />;
};

export default CfBannerPopup;
